import React, { FunctionComponent } from 'react'
import { ChoiceProps } from '../AnswerProps'
import VerticalChoices from './VerticalChoices/VerticalChoices'

const OneOfManyInput: FunctionComponent<ChoiceProps> = ({ question, answer, onSelection }: ChoiceProps) => {
  return (
    <VerticalChoices
      answer={answer}
      onSelection={onSelection}
      question={question}
    />
  )
}

export default OneOfManyInput
